import React from 'react';
import { format } from 'date-fns';
import type {
  MarketingRequest,
  MarketingRequestPatch,
  MarketingRequestPriority,
  MarketingRequestStatus,
  MarketingRequestType,
} from '../../types/marketing';

const TYPE_OPTIONS: { value: MarketingRequestType; label: string }[] = [
  { value: 'content', label: 'Content' },
  { value: 'social', label: 'Social' },
  { value: 'email', label: 'Email' },
  { value: 'graphic', label: 'Graphic' },
  { value: 'podcast', label: 'Podcast' },
  { value: 'website', label: 'Website' },
  { value: 'other', label: 'Other' },
];

const STATUS_OPTIONS: { value: MarketingRequestStatus; label: string }[] = [
  { value: 'open', label: 'Open' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'waiting', label: 'Waiting' },
  { value: 'done', label: 'Done' },
  { value: 'cancelled', label: 'Cancelled' },
];

const PRIORITY_OPTIONS: { value: MarketingRequestPriority; label: string }[] = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];

interface MarketingRequestDetailPanelProps {
  request: MarketingRequest;
  onUpdate: (id: string, patch: MarketingRequestPatch) => void;
}

const MarketingRequestDetailPanel: React.FC<MarketingRequestDetailPanelProps> = ({
  request,
  onUpdate,
}) => {
  const dueInput = request.dueDate
    ? format(request.dueDate.toDate(), 'yyyy-MM-dd')
    : '';

  return (
    <div className="mh-request-detail">
      <div className="mh-request-detail-meta">
        <span>Requested by {request.requestedByName}</span>
        <span>Created {format(request.createdAt.toDate(), 'MMM d, yyyy')}</span>
      </div>

      {request.description && (
        <p className="mh-request-detail-desc">{request.description}</p>
      )}

      <div className="mh-request-detail-fields">
        <label className="mh-field mh-field--inline">
          <span>Status</span>
          <select
            value={request.status}
            onChange={e => onUpdate(request.id, { status: e.target.value as MarketingRequestStatus })}
          >
            {STATUS_OPTIONS.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </label>

        <label className="mh-field mh-field--inline">
          <span>Priority</span>
          <select
            value={request.priority}
            onChange={e => onUpdate(request.id, { priority: e.target.value as MarketingRequestPriority })}
          >
            {PRIORITY_OPTIONS.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </label>

        <label className="mh-field mh-field--inline">
          <span>Type</span>
          <select
            value={request.requestType}
            onChange={e => onUpdate(request.id, { requestType: e.target.value as MarketingRequestType })}
          >
            {TYPE_OPTIONS.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </label>

        <label className="mh-field mh-field--inline">
          <span>Due</span>
          <input
            type="date"
            value={dueInput}
            onChange={e => {
              const v = e.target.value;
              onUpdate(request.id, { dueDate: v ? new Date(v + 'T12:00:00') : null });
            }}
          />
        </label>
      </div>
    </div>
  );
};

export default MarketingRequestDetailPanel;
